import {updateSmoothScroll} from '../scroll-smoother'
import {getUrlParameter, updateUrlParameter} from '../helpers/helper-functions'

$('body').on('click', '.js-accordion-title', function () {
    let accordionContainer = $(this).closest('.js-accordion');
    let curEl = $(this).parent();
    let video = curEl.find('video');

    if (video.length) video[0].play();

    curEl.toggleClass('opened');
    curEl.find('.js-accordion-content').slideToggle();

    // close other accordions
    if (accordionContainer.length) {
        accordionContainer.find('.js-accordion-el').each(function (i, el) {
            if (el !== curEl[0]) {
                $(el).removeClass('opened');
                $(el).find('.js-accordion-content').slideUp();

                let video = $(el).find('video');
                if (video.length) {
                    video[0].pause();
                    video[0].currentTime = 0;
                }
            }
        });
    }

    if (breakpointDown('md')) {
        setTimeout(function () {
            gsap.to(window, {duration: 0.4, scrollTo: curEl[0]});
        }, 400);
    }
});

$('.js-accordion .top').click(function () {
    let accordion = $(this).parent()
    let block = accordion.parent()

    block.find('.js-accordion').each((i, el) => {
        if (el !== accordion[0]) {
            $(el).removeClass('opened')
            $(el).find('.content').slideUp()
        }
    })

    if (accordion.hasClass('opened')) {
        accordion.removeClass('opened')
        accordion.find('.content').slideUp(400, function () {
            updateSmoothScroll()
        })
    } else {
        accordion.addClass('opened')
        accordion.find('.content').slideDown(400, function () {
            updateSmoothScroll()
        })
    }

})
document.addEventListener("DOMContentLoaded", function() {
    $('.js-accordion-open-link').click(function () {
        let permalink = $(this).data('permalink');  // Get the permalink
        console.log(permalink);
        if (permalink) {
            window.location.href = permalink;  // Redirect to the permalink page
        }
    })
})


let pageUrl = $('body').data('page-url')
let openService = getUrlParameter(pageUrl, 'open-service')
if (openService) {
    $('#' + openService).find('.top').click()
    setTimeout(function () {
        $("html, body").animate({scrollTop: $('#' + openService).offset().top - 100}, 400);
    }, 2000)
}
